import React, { useEffect, useRef, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'reactstrap';
import { QuadrantItem } from './quadrant-item';
import { QUADRANTS_ANALYTIC, QUADRANTS_INNOVATIVE, QUADRANTS_RELATIONAL, QUADRANTS_PROCEDURAL, QUADRANTS_ALL } from '../../../core/constants';
import { userResumeActions } from '../../../core/thinking-talents-user-resume/actions';
import { pdfsActions } from '../../../core/pdfs';
import LoadingIndicator from '../loading-indicator';

const quadrantsDefinition = [QUADRANTS_ANALYTIC, QUADRANTS_INNOVATIVE, QUADRANTS_PROCEDURAL, QUADRANTS_RELATIONAL, QUADRANTS_ALL];

export const ThinkingTalentsReportUser = () => {
    const dispatch = useDispatch();
    const { data } = useSelector(state => state.user_resume_TT);
    const user = useSelector(state => state.user);
    let reportBox = useRef();
    const pdf = useSelector(state => state.pdf);

    useEffect(() => {
        dispatch(userResumeActions.loadUserResume())
    }, [dispatch])

    const getFullReportTT = () => {
        dispatch(pdfsActions.loadFullReportTT())
    }

    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => setTooltipOpen(!tooltipOpen);

    return (
        <>
            <div className="d-lg-flex justify-content-between align-items-center mb-3 flex-row-reverse">
                <div className="d-flex align-items-center mb-3 mb-lg-0">
                    <div className='d-flex align-items-center mr-3 text-nowrap' id='ShadowTalent'>
                        <p className='mb-0 font-weight-medium'>Hover over each icon to read a description of each talent and its shadow side</p>
                        <i className='text-muted ml-2'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="d-block bi bi-info-circle-fill" viewBox="0 0 16 16">
                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
                            </svg>
                        </i>
                    </div>
                    <Tooltip placement="bottom" isOpen={tooltipOpen} target="ShadowTalent" toggle={toggle}>
                        Shadow attributes show up when a talent is rough, excessive, or displayed in an unconstructive way. These can show particulary in times of stress for an individual who has these as an ‘always’ talent.
                    </Tooltip>

                    {user && user.access_pdf_tt &&
                        <button onClick={() => getFullReportTT()} className="btn btn-green-light btn-sm">
                            <i className="mr-1">
                                <svg className='d-inline-block mb-1' xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="11" width="11" viewBox="0 0 10.94 10.94">
                                    <path d="M10.94,6.78v3.5c0,.17-.07,.34-.19,.46-.12,.12-.29,.19-.46,.19H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46v-3.5c0-.17,.07-.34,.19-.46,.12-.12,.29-.19,.46-.19s.34,.07,.46,.19c.12,.12,.19,.29,.19,.46v2.84H9.62v-2.84c0-.17,.07-.34,.19-.46,.12-.12,.29-.19,.46-.19s.34,.07,.46,.19c.12,.12,.19,.29,.19,.46Zm-5.93,.46c.06,.06,.13,.11,.21,.14,.08,.03,.17,.05,.25,.05s.17-.02,.25-.05,.15-.08,.21-.14l2.19-2.19c.12-.12,.19-.29,.19-.46s-.07-.34-.19-.46c-.12-.12-.29-.19-.46-.19s-.34,.07-.46,.19l-1.07,1.07V.66c0-.17-.07-.34-.19-.46-.12-.12-.29-.19-.46-.19s-.34,.07-.46,.19c-.12,.12-.19,.29-.19,.46V5.2l-1.07-1.07c-.06-.06-.13-.11-.21-.14-.08-.03-.17-.05-.25-.05-.17,0-.34,.07-.46,.19-.06,.06-.11,.13-.14,.21-.03,.08-.05,.17-.05,.25,0,.17,.07,.34,.19,.46l2.19,2.19Z" />
                                </svg>
                            </i>Thinking Talent Report
                        </button>
                    }
                </div>
                <div className='d-flex'>
                    <p className="mb-0 mr-3">
                        <i className="icon mr-2">
                            <svg width="16" height="16" className="mt-n1 text-always">
                                <circle cx="8" cy="8" r="8" fill="currentColor" />
                            </svg>
                        </i><span className='small'>Always</span>
                    </p>
                    <p className="mb-0 mr-3">
                        <i className="icon mr-2">
                            <svg width="16" height="16" className="mt-n1 border-primary border rounded">
                                <circle cx="8" cy="8" r="8" fill="#ffffff" />
                            </svg>
                        </i><span className='small'>Sometimes</span>
                    </p>
                    <p className="mb-0 mr-3">
                        <i className="icon mr-2">
                            <svg width="16" height="16" className="mt-n1 text-never">
                                <circle cx="8" cy="8" r="8" fill="currentColor" />
                            </svg>
                        </i><span className='small'>Never</span>
                    </p>
                </div>

            </div>
            <div className="quadrants-list full-report" ref={reportBox}>
                <>
                    {quadrantsDefinition.map((name, index) => (
                        <Fragment key={index}>
                            {data.filter(talent => talent.quadrant.name === name).map(talent => (
                                <Fragment key={talent.quadrant.id}>
                                    <QuadrantItem talent={talent} user={user} />
                                </Fragment>
                            )
                            )}
                        </Fragment>
                    ))}
                </>
            </div>

            {
                pdf.isPending &&
                <LoadingIndicator />
            }
        </>
    )
}
